import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Check, Clock, DollarSign, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import servicesData from '../data/services.json';

const ServiceDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [service, setService] = useState(null);

  useEffect(() => {
    const foundService = servicesData.find(s => s.slug === slug);
    setService(foundService);
  }, [slug]);

  if (!service) {
    return (
      <div className="page-not-found">
        <div className="not-found-container">
          <h1>Serviço Não Encontrado</h1>
          <Link to="/services" className="btn-primary">
            <ArrowLeft size={18} />
            {t('services.backToServices')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-service-detail">
      <section className="service-detail-hero">
        <div className="service-detail-container">
          <Link to="/services" className="back-link">
            <ArrowLeft size={18} />
            {t('services.backToServices')}
          </Link>
          
          <h1 className="service-detail-title">{service.title}</h1>
          <p className="service-detail-subtitle">{service.shortDescription}</p>
          
          <div className="service-detail-meta">
            <div className="service-meta-badge">
              <Clock size={20} />
              <span>{service.timeline}</span>
            </div>
            <div className="service-meta-badge">
              <DollarSign size={20} />
              <span>{service.price}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="service-detail-content">
        <div className="service-detail-container">
          {/* Visão Geral */}
          <div className="service-section">
            <h2 className="service-section-title">{t('serviceDetail.overview')}</h2>
            <p className="service-section-text">{service.longDescription}</p>
          </div>

          {/* Features e Deliverables lado a lado */}
          <div className="service-two-columns">
            <div className="service-column">
              <h2 className="service-section-title">{t('serviceDetail.whatsIncluded')}</h2>
              <ul className="service-list">
                {service.features.map((feature, index) => (
                  <li key={index} className="service-list-item">
                    <Check size={20} className="service-list-icon" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className="service-column">
              <h2 className="service-section-title">{t('serviceDetail.deliverables')}</h2>
              <ul className="service-list">
                {service.deliverables.map((deliverable, index) => (
                  <li key={index} className="service-list-item">
                    <Check size={20} className="service-list-icon" />
                    {deliverable}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* CTA Section */}
          <div className="service-cta-section">
            <div className="service-cta-content">
              <h3 className="service-cta-title">{t('serviceDetail.readyTitle')}</h3>
              <p className="service-cta-text">{t('serviceDetail.readyText')}</p>
              <a 
                href="https://wa.me/5588996527079" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-primary"
              >
                {t('services.scheduleConversation')}
                <ArrowRight size={18} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
